var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"author"},[_vm._v("\n    Made from\n    "),_c('a',{attrs:{"href":"https://brianhu.netlify.app/"}},[_vm._v("Brian Hu")])])}]

export { render, staticRenderFns }